import { render, staticRenderFns } from "./Exam-summary.vue?vue&type=template&id=7babf872&scoped=true"
import script from "./Exam-summary.vue?vue&type=script&lang=js"
export * from "./Exam-summary.vue?vue&type=script&lang=js"
import style0 from "./Exam-summary.vue?vue&type=style&index=0&id=7babf872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7babf872",
  null
  
)

export default component.exports